/* NEXORA · home Halo: oferta del día, pestañas, filtros, halo que sigue al cursor y apariciones.
   Módulo: aunque varias secciones lo carguen, se ejecuta una sola vez. */
const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const finePointer = window.matchMedia('(pointer: fine)').matches;
const nativeTimeline = CSS.supports('animation-timeline: view()');

const restart = (el, cls) => {
  el.classList.remove(cls);
  void el.offsetWidth;
  el.classList.add(cls);
};

/* Hora de Lima: UTC-5 todo el año (Perú no usa horario de verano). */
const limaNow = () => {
  const d = new Date();
  return new Date(d.getTime() + d.getTimezoneOffset() * 6e4 - 5 * 36e5);
};

function initOffer(hero) {
  const openH = Number(hero.dataset.openH);
  const closeH = Number(hero.dataset.closeH);
  const daily = hero.dataset.daily === 'true';
  const h1 = hero.querySelector('[data-nxh-h1]');
  const cd = hero.querySelector('[data-nxh-cd]');
  const openTpl = hero.querySelector('template[data-open-h1]');
  const closedTpl = hero.querySelector('template[data-closed-h1]');
  const units = { h: 36e5, m: 6e4, s: 1e3 };
  const last = {};
  let state = null;

  const setState = (open) => {
    if (state === open) return;
    const first = state === null;
    state = open;
    hero.classList.toggle('nxh-offer-closed', !open);
    const tpl = open ? openTpl : closedTpl;
    if (h1 && tpl) h1.innerHTML = tpl.innerHTML;
    if (cd) cd.hidden = !open;
    if (h1 && !first) restart(h1, 'nxh-in');
  };

  const isOpen = (h) => (openH < closeH ? h >= openH && h < closeH : h >= openH || h < closeH);

  const tick = () => {
    if (!daily) return setState(true);
    const now = limaNow();
    const open = isOpen(now.getHours());
    setState(open);
    if (!open || !cd) return;
    const end = new Date(now);
    end.setHours(closeH, 0, 0, 0);
    if (end <= now) end.setDate(end.getDate() + 1);
    let left = end - now;
    for (const k of Object.keys(units)) {
      const v = Math.floor(left / units[k]);
      left -= v * units[k];
      const t = String(v).padStart(2, '0');
      const el = cd.querySelector(`[data-u="${k}"]`);
      if (el && last[k] !== t) {
        el.textContent = t;
        if (last[k] !== undefined && !reduce) restart(el, 'nxh-tick');
        last[k] = t;
      }
    }
  };

  tick();
  hero._nxhTimer = setInterval(tick, 1000);

  requestAnimationFrame(() => h1?.classList.add('nxh-in'));
  setTimeout(() => hero.querySelectorAll('.nxh-stk.nxh-pop').forEach((s) => s.classList.add('nxh-in')), 700);

  const stage = hero.querySelector('[data-nxh-stage]');
  if (stage && !reduce && finePointer) {
    let raf = 0;
    let tx = 0;
    let ty = 0;
    hero._nxhMove = (e) => {
      tx = (e.clientX / innerWidth - 0.5) * 2;
      ty = (e.clientY / innerHeight - 0.5) * 2;
      if (raf) return;
      raf = requestAnimationFrame(() => {
        stage.style.setProperty('--mx', tx.toFixed(3));
        stage.style.setProperty('--my', ty.toFixed(3));
        raf = 0;
      });
    };
    window.addEventListener('pointermove', hero._nxhMove, { passive: true });
  }
}

function initTabs(list, onChange) {
  const btns = [...list.querySelectorAll('[role="tab"]')];
  const select = (b, focus) => {
    for (const x of btns) {
      const on = x === b;
      const panel = document.getElementById(x.getAttribute('aria-controls'));
      x.setAttribute('aria-selected', on);
      x.tabIndex = on ? 0 : -1;
      if (panel) {
        panel.hidden = !on;
        if (on) restart(panel, 'nxh-swap');
      }
    }
    if (focus) b.focus();
    onChange?.(b);
  };
  btns.forEach((b, i) => {
    b.addEventListener('click', () => select(b));
    b.addEventListener('keydown', (e) => {
      const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
      if (!d) return;
      e.preventDefault();
      select(btns[(i + d + btns.length) % btns.length], true);
    });
  });
  if (btns[0]) onChange?.(btns[0]);
}

function initSeg(seg) {
  const thumb = seg.querySelector('.nxh-thumb');
  const place = (b) => {
    if (!thumb || !b) return;
    thumb.style.width = `${b.offsetWidth}px`;
    thumb.style.transform = `translateX(${b.offsetLeft - 5}px)`;
  };
  initTabs(seg, place);
  new ResizeObserver(() => place(seg.querySelector('[aria-selected="true"]'))).observe(seg);
}

function initFilters(root) {
  const btns = root.querySelectorAll('[data-f]');
  const cards = root.querySelectorAll('.nxh-pcard');
  btns.forEach((b) =>
    b.addEventListener('click', () => {
      btns.forEach((x) => x.setAttribute('aria-pressed', x === b));
      cards.forEach((c) => {
        const tags = (c.dataset.tag || '').split(' ');
        const show = !b.dataset.f || tags.includes(b.dataset.f);
        c.hidden = !show;
        if (show && !reduce) restart(c, 'nxh-show');
      });
    })
  );
}

function initSpot(card) {
  if (reduce || !finePointer) return;
  card.addEventListener('pointermove', (e) => {
    const r = card.getBoundingClientRect();
    card.style.setProperty('--x', `${e.clientX - r.left}px`);
    card.style.setProperty('--y', `${e.clientY - r.top}px`);
  });
}

let io;
const observe = (el) => {
  if (reduce || !('IntersectionObserver' in window)) {
    el.classList.add('nxh-in');
    return;
  }
  io ??= new IntersectionObserver(
    (entries) => {
      for (const e of entries) {
        if (!e.isIntersecting) continue;
        e.target.classList.add('nxh-in');
        io.unobserve(e.target);
      }
    },
    { threshold: 0.25 }
  );
  io.observe(el);
};

function init(scope) {
  scope.querySelectorAll('[data-nxh-offer]').forEach(initOffer);
  scope.querySelectorAll('[data-nxh-seg]').forEach(initSeg);
  scope.querySelectorAll('[data-nxh-tabs]').forEach((t) => initTabs(t));
  scope.querySelectorAll('[data-nxh-filters]').forEach(initFilters);
  scope.querySelectorAll('[data-spot]').forEach(initSpot);
  const sel = nativeTimeline ? '.nxh-chat .nxh-reveal-b' : '[data-rise], .nxh-chat .nxh-reveal-b';
  scope.querySelectorAll(sel).forEach(observe);
}

init(document);

document.addEventListener('shopify:section:load', (e) => init(e.target));
document.addEventListener('shopify:section:unload', (e) => {
  e.target.querySelectorAll('[data-nxh-offer]').forEach((hero) => {
    clearInterval(hero._nxhTimer);
    if (hero._nxhMove) window.removeEventListener('pointermove', hero._nxhMove);
  });
});
